<!--
고객문의 게시판 > 일괄작업
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
------------------------------------
-->
<template>
    <div
        class="wrapper"
        :uk-sticky="onSticky && itemCheckedCount > 0"
    >
        <div class="uk-flex uk-flex-between uk-flex-bottom">
            <button
                class="uk-button uk-button-primary uk-margin-right"
                type="button"
                :disabled="disabled"

                @click="$refs['state-to-done'].jobInit()"
            >
                <i class="material-icons">done</i>
                선택항목 완료처리
            </button>

            <!-- 선택개수안내 -->
            <div class="selected-msg" v-show="itemCheckedCount > 0" v-html="itemCheckedInfo"></div>

            <!-- 선택된 아이템 없음 -->
            <div class="no-selected-msg" v-show="itemCheckedCount === 0">
                {{ batch.item_checked_nothing_msg }}
            </div>

        </div>


        <!-- 완료처리 기능 -->
        <state-to-done
            ref="state-to-done"
            :batch="batch"
            :csrfToken="csrfToken"
        ></state-to-done>
    </div>

</template>

<script>
    import checkedCountable from '../../checked-countable';
    import stickiable from '../../stickable';

    export default {
        mixins: [
            checkedCountable,
            stickiable,
        ],
        components: {
            'state-to-done': require('./state-to-done.vue').default,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * 관리자권한 여부
             */
            hasAdmin: {
                type: Boolean,
                default: false
            },
        },
        data: function () {

            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.5rem;
    }

</style>